import { Component, OnInit } from '@angular/core';
import {AhmService} from "../../services/ahm.service";
import {Router} from '@angular/router';
import {AjaxService} from '../../services/ajax.service';

@Component({
  selector: 'app-right-panel',
  templateUrl: './right-panel.component.html',
  styleUrls: ['./right-panel.component.css']
})
export class RightPanelComponent implements OnInit {

  diplomButtonLink = ''; // https://ridero.ru/books/alphabet_of_the_human_mind/';
  diplomButtonImage = '../assets/images/button_di_bw_1339.png';
  qaButtonLink = 'construction'; // https://ridero.ru/books/alphabet_of_the_human_mind/';
  qaButtonImage = '../assets/images/button_qa_bw_1339.png';
  ttButtonLink = 'construction'; // https://ridero.ru/books/alphabet_of_the_human_mind/';
  ttButtonImage = '../assets/images/button_tt_bw_1339.png';
  frButtonLink = 'construction'; // https://ridero.ru/books/alphabet_of_the_human_mind/';
  frButtonImage = '../assets/images/button_fr_bw_1339.png';
  hsButtonImage  = '../assets/images/buttons/hospital1_bw.png';
  psyButtonImage = '../assets/images/buttons/psymodeler_bw.png';



  constructor(private service: AhmService, private router: Router, private ajax: AjaxService) { }

  // set color button for selected item
  setColorButton(button){
    switch (button) {
      case 'diplom': {
        this.diplomButtonImage = '../assets/images/button_di_color_1339.png';
        break;
      }
      case 'qa': {
        this.qaButtonImage = '../assets/images/button_qa_color_1339.png';
        break;
      }
      case 'tt': {
        this.ttButtonImage = '../assets/images/button_tt_color_1339.png';
        break;
      }
      case 'fr': {
        this.frButtonImage = '../assets/images/button_fr_color_1339.png';
        break;
      }
      case 'psy': {
        this.psyButtonImage = '../assets/images/buttons/psymodeler.png';
        break;
      }
    }
  }
  // set black and white button for selected item
  setBWButton(button){
    switch (button) {
      case 'diplom': {
        this.diplomButtonImage = '../assets/images/button_di_bw_1339.png';
        break;
      }
      case 'qa': {
        this.qaButtonImage = '../assets/images/button_qa_bw_1339.png';
        break;
      }
      case 'tt': {
        this.ttButtonImage = '../assets/images/button_tt_bw_1339.png';
        break;
      }
      case 'fr': {
        this.frButtonImage = '../assets/images/button_fr_bw_1339.png';
        break;
      }
      case 'psy': {
        this.psyButtonImage = '../assets/images/buttons/psymodeler_bw.png';
        break;
      }
    }
  }

  // load diploms section into dynamic component
  diploms() {
    this.service.loadDyploms();
  }

  ngOnInit() {
  }

  /**
   *
   */
  psyModeler() {
    let ajaxUserId = this.ajax.id;
    this.router.navigate(['/psymodeler']);
  }

  /**
   * show hospital component
   */
  nonViolenceHospital() {
    this.service.setHospital();
  }

}
